import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "./brand/Logo";
import GetAppButton from "./getapp/GetAppButton";

const LINKS = [
  ["About", "/about"],
  ["Contact", "/contact"],
  ["Refund policy", "/refund-policy"],
  ["Privacy", "/privacy"],
  ["Data deletion", "/data-deletion"],
];

export const SiteFooter = () => {
  const { pathname } = useLocation();
  return (
  <footer className="border-t border-slate-200/80 bg-slate-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 flex flex-col md:flex-row gap-8 md:items-center md:justify-between">
      <div className="space-y-3 max-w-sm">
        <Logo />
        <p className="text-sm text-slate-500 leading-relaxed">
          Describe it, watch it build, publish it. Ishukart turns plain-language ideas into live web apps.
        </p>
        {pathname !== "/get-app" && <GetAppButton testid="footer-get-app-btn" className="mt-2" />}
      </div>
      <nav className="flex flex-wrap gap-x-8 gap-y-3 text-sm text-slate-500">
        {LINKS.map(([label, to]) => (
          <Link key={to} to={to} className="hover:text-slate-900 transition-colors" data-testid={`footer-link-${to.slice(1)}`}>
            {label}
          </Link>
        ))}
      </nav>
    </div>
    <div className="border-t border-slate-200 py-5 text-center text-xs font-mono text-slate-400">
      © {new Date().getFullYear()} Ishukart · support@ishukart.org
    </div>
  </footer>
  );
};

export default SiteFooter;
